import { baseApi } from "@/redux/api/baseApi";

const videoEditingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getVideoEditing: builder.query({
      query: ({ orderId, videoId }) => ({
        url: `/video-editing/${orderId}/${videoId}`,
        method: "GET",
      }),
      providesTags: ["video-editing"],
    }),

    uploadVideoEditingFile: builder.mutation({
      query: (payload) => ({
        url: `/video-editing/${payload.order_id}/${payload.video_id}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["video-editing", "OrderDetails"],
    }),

    uploadRevisedVideoEditingFile: builder.mutation({
      query: (payload) => ({
        url: `/video-editing/upload-new-version/${payload.orderId}/${payload.videoId}`,
        method: "POST",
        body: payload.data,
      }),
      invalidatesTags: ["video-editing", "OrderDetails"],
    }),

    requestVideoEditingTimeLineExtension: builder.mutation({
      query: ({ orderId, videoId, body }) => ({
        url: `/video-editing/request-an-extension/${orderId}/${videoId}`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["video-editing"],
    }),
  }),
});

export const {
  useGetVideoEditingQuery,
  useUploadRevisedVideoEditingFileMutation,
  useUploadVideoEditingFileMutation,
  useRequestVideoEditingTimeLineExtensionMutation,
} = videoEditingApi;
